import { cacheApi } from '../../../../helpers/cacheExpiry.js';
import RequestQueueManager from '../../../../helpers/requestQueueManager';

const fontsApiQueue = new RequestQueueManager();

/**
 * This function fetches the fonts from the Google Fonts API
 * is using the cacheApi helper function to cache the response
 * and the RequestQueueManager to manage the requests when multiple components have be rendered
 * at the same time.
 * @param apiKey
 * @returns
 */
export const fetchFonts = apiKey => {
  const jobID = fontsApiQueue.enqueueProcess(() => {
    return cacheApi({
      path: `https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}&sort=popularity`,
      params: {
        cache: '1w',
      },
      options: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      responseHandler: response => {
        return response.json();
      },
    });
  });

  return fontsApiQueue.waitForProcessCompletion(jobID);
};
